// extracted by mini-css-extract-plugin
export default {"backdrop":"DeactivateModal_backdrop__nHgxG","card":"DeactivateModal_card__K2PZ7","fadeInScale":"DeactivateModal_fadeInScale__Gu915","actions":"DeactivateModal_actions__VRPhv"};